import { render } from "./BaseReviewMsg.vue?vue&type=template&id=f82c6386"
import script from "./BaseReviewMsg.vue?vue&type=script&lang=js"
export * from "./BaseReviewMsg.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\leste\\OneDrive\\Desktop\\Target-Innovations\\01-Active-Projects\\Target - marido-en-alquiler-web-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__